import React, { memo } from 'react';

const FooterTodo = () => {
    return (
        <a
            href='https://docs.vmass.vn/quan-ly/ban-ghe'
            target='_blank'
            className='mb-0 pl-3'
        >
            Hướng dẫn
        </a>
    );
};

export default memo(FooterTodo);
